/**
 * Сессия клиента в localStorage после регистрации / входа по коду.
 */

export const CLIENT_SESSION_KEY = "potok_client_session";

export type ClientSession = {
  personalCode: string;
  clientId: string;
  fullName: string;
  company: string;
  position: string;
  region: string | null;
};

export function readClientSession(): ClientSession | null {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const raw = window.localStorage.getItem(CLIENT_SESSION_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as Partial<ClientSession>;
    if (
      typeof parsed.personalCode !== "string" ||
      parsed.personalCode.length !== 8 ||
      typeof parsed.clientId !== "string" ||
      typeof parsed.fullName !== "string" ||
      typeof parsed.company !== "string" ||
      typeof parsed.position !== "string"
    ) {
      return null;
    }
    return {
      personalCode: parsed.personalCode,
      clientId: parsed.clientId,
      fullName: parsed.fullName,
      company: parsed.company,
      position: parsed.position,
      region: typeof parsed.region === "string" ? parsed.region : null,
    };
  } catch {
    return null;
  }
}

export function writeClientSession(session: ClientSession): void {
  try {
    window.localStorage.setItem(CLIENT_SESSION_KEY, JSON.stringify(session));
  } catch {
    /* private mode / broken storage */
  }
}

export function clearClientSession(): void {
  try {
    window.localStorage.removeItem(CLIENT_SESSION_KEY);
  } catch {
    /* ignore */
  }
}
